module.exports = __webpack_public_path__ + "images/FUSA_icons/038-laptop.a6eaa92e48ca35e3f8b4c14b886db7b8.svg";